/**
 * @fileoverview Custom error class for normalized API failures.
 * @description Every rejected request the shared Axios instance produces rejects with an instance
 * of this class rather than a plain object, so the rejection is always a real Error (with a stack
 * trace) while still carrying the app's normalized error code and HTTP status.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import type { ErrorCode } from '@/shared/constants/error-codes.constants'

export class ApiException extends Error {
  code: ErrorCode
  status?: number | undefined

  /**
   * @param {ErrorCode} code - The app's normalized error code.
   * @param {string} message - A user-facing message describing the failure.
   * @param {number} [status] - The HTTP status code, when the failure came from a response.
   */
  constructor(code: ErrorCode, message: string, status?: number) {
    super(message)
    this.name = 'ApiException'
    this.code = code
    this.status = status
  }
}
